export default __webpack_public_path__ + "static/media/b3.f195745f.jpg";